module.exports = __webpack_public_path__ + "static/media/workprocess3.29a6e298.png";